module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bH1Xb"))).then(() => parcelRequire('hEqeo'));